/**
 * FBSBancaRIOBAMBA
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DepositoModeloMLS { 
    secuencial?: number;
    codigo?: string | null;
    tipoDeposito?: string | null;
    moneda?: string | null;
    estado?: string | null;
    fechaVencimiento?: string | null;
    monto?: number | null;
    saldoInteresCobro?: number | null;
    saldoInteresCalculo?: number | null;
    fechaApertura?: string;
}

